import scroll from "scroll"
import scrollDoc from "scroll-doc"

const scrollToRef = (ref, offset = 120) => {
  const page = scrollDoc()
  if (ref) {
    const offsetTop = ref.current.offsetTop - offset
    scroll.top(page, offsetTop)
  }
}

export default scrollToRef
